import {initCartAll} from "./cart-dropdown--all"
import {initCartSingle} from "./cart-dropdown--single"
import {reinitHeaderCart} from "../../components/main-header/main-header-cart/main-header-cart";
import {initCounters} from "../../components/counter/counter";

export const rerenderCartDropdown = (html: string, price: string, amount: number) => {
  const headerCartOriginal = document.querySelector(".i-cart-overview")
  const itemsWrapper = document.querySelector(".i-cart-overview__products")
  const headerCartPriceWrapper = document.querySelector('.main-header-cart__value');
  const headerCartAmount = document.querySelector('.main-header-cart__amount');

  const scroll = itemsWrapper?.scrollTop

  headerCartOriginal?.insertAdjacentHTML("afterend", html)
  headerCartOriginal?.remove()

  if(headerCartAmount) {
    headerCartAmount.innerHTML = amount.toString();
    if(amount > 0) headerCartAmount.classList.add('--active');
    else headerCartAmount.classList.remove('--active');
  }

  reinitHeaderCart()
  initCartAll()
  initCartSingle()
  initCounters(document.querySelectorAll(".i-cart-overview .c-counter"))

  if(headerCartPriceWrapper) headerCartPriceWrapper.innerHTML = price

  const newItemsWrapper = document.querySelector(".i-cart-overview__products")
  newItemsWrapper?.scrollTo({top: scroll, behavior: "instant"})
}
